// Shrine theme core .js is closed source so there's no way to fix this directly in the code.
// But the problem itself is coming from Shrine - they're not mapping things properly.
// Ugly workaround but that's what you get when code is closed source.

(function () {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    if (typeof args[0] === "string" && args[0].includes("/cart/add")) {
      let options = args[1] || {};
      const kachingBundles = document.querySelector("kaching-bundles-block");

      if (
        kachingBundles &&
        typeof kachingBundles.selectedVariants === "function"
      ) {
        const selectedVariants = kachingBundles.selectedVariants();

        if (Array.isArray(selectedVariants) && selectedVariants.length > 1) {
          if (options.body instanceof FormData) {
            let newFormData = new FormData();

            for (let [key, value] of options.body.entries()) {
              if (key !== "properties[__kaching_bundles]") {
                newFormData.append(key, value);
              }
            }

            const kachingBundlesValue = options.body.get(
              "properties[__kaching_bundles]"
            );
            if (kachingBundlesValue) {
              newFormData.append(
                "items[1][properties][__kaching_bundles]",
                kachingBundlesValue
              );
            }

            options.body = newFormData;
          }
        }
      }

      return originalFetch(args[0], options);
    }
    return originalFetch(...args);
  };
})();
